import { render, staticRenderFns } from "./sushi-boat-info.vue?vue&type=template&id=7106a6c7&"
import script from "./sushi-boat-info.vue?vue&type=script&lang=js&"
export * from "./sushi-boat-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports